var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowntime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 487,
    viewBox: "0 0 566 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.947 355.654C429.947 392.116 444.427 427.085 470.202 452.867C477.172 459.84 477.172 471.145 470.201 478.117C458.362 489.959 439.169 489.959 427.33 478.117C421.411 472.196 413.653 469.236 405.895 469.236C398.137 469.236 390.378 472.196 384.46 478.117C378.505 484.074 370.687 487.034 362.882 486.998C355.171 486.963 347.472 484.003 341.589 478.117C335.527 472.054 327.537 469.096 319.592 469.242C312.023 469.381 304.496 472.339 298.719 478.117C291.32 485.518 281.048 488.294 271.494 486.443C265.762 485.334 260.288 482.558 255.849 478.117C249.929 472.196 242.172 469.236 234.413 469.236C226.655 469.236 218.897 472.196 212.978 478.117C206.449 484.648 197.683 487.577 189.148 486.904C182.206 486.357 175.417 483.429 170.107 478.117C163.967 471.976 155.849 469.019 147.804 469.248C140.337 469.461 132.934 472.418 127.236 478.117C115.397 489.959 96.2036 489.959 84.3652 478.117C77.3945 471.146 77.3945 459.842 84.3652 452.869L84.3662 452.868C110.141 427.086 124.621 392.118 124.621 355.656L124.621 326.233C124.621 303.987 124.359 274.991 124.359 222.545C124.38 222.517 124.393 222.498 124.393 222.498L124.621 152.706C124.621 68.3689 192.97 0 277.284 0C361.597 0 429.947 68.3689 429.947 152.706V355.654Z",
    fill: "url(#paint0_linear_1978_563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.947 355.654C429.947 392.116 444.427 427.085 470.202 452.867C477.172 459.84 477.172 471.145 470.201 478.117C458.362 489.959 439.169 489.959 427.33 478.117C421.411 472.196 413.653 469.236 405.895 469.236C398.137 469.236 390.378 472.196 384.46 478.117C378.505 484.074 370.687 487.034 362.882 486.998C355.171 486.963 347.472 484.003 341.589 478.117C335.527 472.054 327.537 469.096 319.592 469.242C312.023 469.381 304.496 472.339 298.719 478.117C291.32 485.518 281.048 488.294 271.494 486.443C265.762 485.334 260.288 482.558 255.849 478.117C249.929 472.196 242.172 469.236 234.413 469.236C226.655 469.236 218.897 472.196 212.978 478.117C206.449 484.648 197.683 487.577 189.148 486.904C182.206 486.357 175.417 483.429 170.107 478.117C163.967 471.976 155.849 469.019 147.804 469.248C140.337 469.461 132.934 472.418 127.236 478.117C115.397 489.959 96.2036 489.959 84.3652 478.117C77.3945 471.146 77.3945 459.842 84.3652 452.869L84.3662 452.868C110.141 427.086 124.621 392.118 124.621 355.656L124.621 326.233C122.503 307.249 124.359 240.405 124.359 222.545C124.38 222.517 124.393 222.498 124.393 222.498L124.621 152.706C124.621 68.3689 192.97 0 277.284 0C361.597 0 429.947 68.3689 429.947 152.706V355.654Z",
    fill: "url(#paint1_linear_1978_563)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.621 342.149V355.656C124.621 392.118 110.141 427.086 84.3663 452.868L84.3653 452.869C77.3946 459.842 77.3946 471.146 84.3653 478.118C96.2037 489.959 115.398 489.959 127.236 478.118C132.934 472.418 140.337 469.461 147.804 469.249C155.849 469.019 163.967 471.976 170.107 478.118C175.417 483.429 182.206 486.357 189.148 486.905C197.683 487.577 206.449 484.648 212.978 478.118C218.897 472.196 226.655 469.236 234.413 469.236C242.172 469.236 249.929 472.196 255.849 478.118C260.288 482.558 265.762 485.334 271.494 486.443C281.048 488.294 291.32 485.518 298.719 478.118C304.496 472.34 312.023 469.381 319.592 469.242C327.537 469.096 335.527 472.054 341.589 478.118C347.472 484.003 355.171 486.963 362.882 486.998C370.687 487.034 378.505 484.074 384.46 478.118C390.378 472.196 398.137 469.236 405.895 469.236C413.653 469.236 421.411 472.196 427.33 478.118C439.169 489.959 458.362 489.959 470.201 478.118C477.172 471.145 477.172 459.84 470.201 452.867C444.426 427.085 429.946 392.116 429.946 355.655V342.148H124.621V342.149Z",
    fill: "url(#paint2_linear_1978_563)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.57 91.4302C179.556 86.776 187.979 80.2434 194.517 72.5815C198.642 67.7489 206.328 72.9084 203.398 78.5553C197.59 89.748 188.175 99.1872 175.865 104.929C163.548 110.671 150.269 111.818 137.959 109.072C131.754 107.687 132.734 98.4858 139.094 98.4323C149.164 98.3491 159.584 96.0903 169.57 91.4361V91.4302Z",
    fill: "url(#paint3_linear_1978_563)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.543 91.4302C306.557 86.776 298.135 80.2434 291.596 72.5815C287.471 67.7489 279.785 72.9084 282.716 78.5553C288.523 89.748 297.938 99.1872 310.249 104.929C322.565 110.671 335.844 111.818 348.154 109.072C354.36 107.687 353.379 98.4858 347.019 98.4323C336.949 98.3491 326.529 96.0903 316.543 91.4361V91.4302Z",
    fill: "url(#paint4_linear_1978_563)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.207 242C165.563 242.133 161.924 242.133 158.28 242C139.588 241.314 124.567 226.293 123.881 207.602C123.748 203.958 123.748 200.319 123.881 196.675C124.567 177.984 139.588 162.962 158.28 162.276C161.924 162.143 165.563 162.143 169.207 162.276C187.898 162.962 202.919 177.984 203.605 196.675C203.738 200.319 203.738 203.958 203.605 207.602C202.919 226.293 187.898 241.314 169.207 242Z",
    fill: "url(#paint5_radial_1978_563)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M355.971 257.707C351.61 257.866 347.255 257.866 342.894 257.707C320.525 256.886 302.548 238.909 301.727 216.54C301.568 212.179 301.568 207.824 301.727 203.463C302.548 181.094 320.525 163.117 342.894 162.296C347.255 162.137 351.61 162.137 355.971 162.296C378.34 163.117 396.318 181.094 397.138 203.463C397.298 207.824 397.298 212.179 397.138 216.54C396.318 238.909 378.34 256.886 355.971 257.707Z",
    fill: "url(#paint6_radial_1978_563)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.268 179.767C195.738 179.767 213.954 161.546 213.954 139.07C213.954 116.593 195.738 98.3728 173.268 98.3728C150.798 98.3728 132.583 116.593 132.583 139.07C132.583 161.546 150.798 179.767 173.268 179.767Z",
    fill: "url(#paint7_linear_1978_563)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.892 179.767C330.362 179.767 348.578 161.546 348.578 139.07C348.578 116.593 330.362 98.3728 307.892 98.3728C285.422 98.3728 267.207 116.593 267.207 139.07C267.207 161.546 285.422 179.767 307.892 179.767Z",
    fill: "url(#paint8_linear_1978_563)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.999 213.309C270.41 213.309 268.871 213.496 267.407 213.847C262.033 215.142 256.346 213.82 252.035 210.363C249.063 207.979 245.406 206.577 241.446 206.577C237.486 206.577 233.829 207.983 230.857 210.363C226.541 213.82 220.86 215.142 215.485 213.847C214.021 213.496 212.482 213.309 210.893 213.309C200.94 213.309 192.87 220.686 192.87 229.789C192.87 238.892 200.94 246.269 210.893 246.269C217.683 246.269 223.591 242.838 226.661 237.766C229.918 242.905 235.324 246.269 241.446 246.269C247.568 246.269 252.974 242.905 256.231 237.766C259.305 242.834 265.214 246.269 271.999 246.269C281.952 246.269 290.023 238.892 290.023 229.789C290.023 220.686 281.952 213.309 271.999 213.309Z",
    fill: "url(#paint9_linear_1978_563)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 213.309C212.482 213.309 214.021 213.496 215.485 213.847C220.86 215.142 226.546 213.82 230.857 210.363C233.829 207.979 237.486 206.577 241.446 206.577C245.406 206.577 249.063 207.983 252.035 210.363C256.351 213.82 262.033 215.142 267.407 213.847C268.871 213.496 270.41 213.309 271.999 213.309C281.952 213.309 290.023 220.686 290.023 229.789C290.023 238.892 281.952 246.269 271.999 246.269C265.209 246.269 259.301 242.838 256.231 237.766C252.974 242.905 247.568 246.269 241.446 246.269C235.324 246.269 229.918 242.905 226.661 237.766C223.587 242.834 217.678 246.269 210.893 246.269C200.94 246.269 192.87 238.892 192.87 229.789C192.87 220.686 200.94 213.309 210.893 213.309Z",
    fill: "url(#paint10_linear_1978_563)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M355.346 131.919C355.346 135.612 354.251 139.341 351.973 142.593L300.807 215.662C300.807 215.662 300.803 215.645 300.799 215.636C296.114 203.222 283.206 195.766 270.117 197.906L270.059 197.914C269.263 198.044 268.462 198.079 267.661 198.026L321.443 121.215C327.347 112.783 338.968 110.732 347.4 116.636C352.574 120.262 355.346 126.046 355.346 131.919Z",
    fill: "url(#paint11_linear_1978_563)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M344.748 139.545C343.093 141.908 340.672 143.416 338.056 143.972C335.289 144.564 332.824 146.139 331.2 148.461L292.372 203.916C289.769 201.785 286.797 200.13 283.611 199.04L322.96 142.842C324.58 140.529 325.349 137.69 324.922 134.896C324.464 131.893 325.247 128.689 327.423 126.131C330.751 122.211 336.481 121.143 340.988 123.608C346.83 126.803 348.459 134.246 344.748 139.545Z",
    fill: "url(#paint12_linear_1978_563)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.188 159.858L332.464 162.851C333.625 163.665 333.908 165.265 333.095 166.425C332.283 167.585 330.683 167.867 329.521 167.054L325.246 164.06C324.085 163.247 323.802 161.647 324.614 160.487C325.427 159.326 327.027 159.045 328.188 159.858Z",
    fill: "url(#paint13_linear_1978_563)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.592 169.283L325.867 172.276C327.028 173.089 327.311 174.689 326.499 175.85C325.687 177.01 324.086 177.292 322.925 176.478L318.65 173.485C317.488 172.671 317.206 171.072 318.018 169.911C318.83 168.751 320.431 168.47 321.592 169.283Z",
    fill: "url(#paint14_linear_1978_563)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M314.991 178.708L319.266 181.701C320.428 182.514 320.711 184.114 319.898 185.275C319.086 186.435 317.485 186.717 316.324 185.903L312.049 182.91C310.888 182.097 310.605 180.497 311.417 179.336C312.229 178.176 313.829 177.894 314.991 178.708Z",
    fill: "url(#paint15_linear_1978_563)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M308.394 188.128L312.67 191.121C313.831 191.935 314.114 193.535 313.301 194.695C312.489 195.855 310.889 196.137 309.727 195.324L305.452 192.33C304.291 191.517 304.008 189.917 304.82 188.757C305.633 187.596 307.233 187.315 308.394 188.128Z",
    fill: "url(#paint16_linear_1978_563)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.793 197.553L306.069 200.547C307.23 201.36 307.513 202.96 306.7 204.12C305.888 205.281 304.288 205.562 303.126 204.749L298.851 201.756C297.69 200.942 297.407 199.342 298.219 198.182C299.032 197.022 300.632 196.74 301.793 197.553Z",
    fill: "url(#paint17_linear_1978_563)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M355.346 131.919C355.346 135.612 354.251 139.341 351.973 142.593L300.807 215.662C300.807 215.662 300.803 215.645 300.799 215.636C296.114 203.222 283.206 195.766 270.117 197.906L270.059 197.914C269.263 198.044 268.462 198.079 267.661 198.026L321.443 121.215C327.347 112.783 338.968 110.732 347.4 116.636C352.574 120.262 355.346 126.046 355.346 131.919Z",
    fill: "url(#paint18_linear_1978_563)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M355.346 131.919C355.346 135.612 354.251 139.341 351.973 142.593L300.807 215.662C300.807 215.662 300.803 215.645 300.799 215.636C296.114 203.222 283.206 195.766 270.117 197.906L270.059 197.914C269.263 198.044 268.462 198.079 267.661 198.026L321.443 121.215C327.347 112.783 338.968 110.732 347.4 116.636C352.574 120.262 355.346 126.046 355.346 131.919Z",
    fill: "url(#paint19_linear_1978_563)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.761 159.322L267.661 198.026C268.462 198.079 269.263 198.044 270.059 197.914L270.117 197.906C283.206 195.766 296.114 203.222 300.799 215.636C300.799 215.645 300.799 215.653 300.807 215.662L323.783 182.854C314.324 175.179 302.707 165.756 294.761 159.322Z",
    fill: "url(#paint20_linear_1978_563)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M303.486 213.789C303.41 213.562 303.335 213.353 303.263 213.162C298.578 200.749 285.676 193.292 272.559 195.436C267.794 196.215 262.922 193.572 259.172 190.511L259.141 190.484C248.885 182.106 233.998 182.106 223.756 190.475L223.703 190.52C219.965 193.572 215.089 196.21 210.359 195.441L210.302 195.432C197.208 193.292 184.305 200.753 179.62 213.162C179.549 213.349 179.477 213.558 179.402 213.78C177.119 220.588 187.188 224.231 189.844 217.558C189.906 217.402 189.969 217.246 190.027 217.086C192.847 209.611 200.62 205.118 208.473 206.399L208.531 206.408C216.437 207.698 224.53 207.311 230.723 202.252L230.777 202.208C236.952 197.162 245.922 197.162 252.111 202.217L252.142 202.243C258.344 207.311 266.442 207.694 274.37 206.404C282.254 205.113 290.031 209.607 292.852 217.086C292.915 217.246 292.972 217.402 293.039 217.562C295.695 224.231 305.764 220.592 303.481 213.785L303.486 213.789Z",
    fill: "url(#paint21_linear_1978_563)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M303.486 213.789C303.41 213.562 303.335 213.353 303.263 213.162C298.578 200.749 285.676 193.292 272.559 195.436C267.794 196.215 262.922 193.572 259.172 190.511L259.141 190.484C248.885 182.106 233.998 182.106 223.756 190.475L223.703 190.52C219.965 193.572 215.089 196.21 210.359 195.441L210.302 195.432C197.208 193.292 184.305 200.753 179.62 213.162C179.549 213.349 179.477 213.558 179.402 213.78C177.119 220.588 187.188 224.231 189.844 217.558C189.906 217.402 189.969 217.246 190.027 217.086C192.847 209.611 200.62 205.118 208.473 206.399L208.531 206.408C216.437 207.698 224.53 207.311 230.723 202.252L230.777 202.208C236.952 197.162 245.922 197.162 252.111 202.217L252.142 202.243C258.344 207.311 266.442 207.694 274.37 206.404C282.254 205.113 290.031 209.607 292.852 217.086C292.915 217.246 292.972 217.402 293.039 217.562C295.695 224.231 305.764 220.592 303.481 213.785L303.486 213.789Z",
    fill: "url(#paint22_linear_1978_563)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.407 213.789C179.482 213.562 179.558 213.353 179.629 213.162C184.314 200.749 197.217 193.292 210.333 195.436C215.098 196.215 219.97 193.572 223.721 190.511L223.752 190.484C234.007 182.106 248.894 182.106 259.136 190.475L259.19 190.52C262.927 193.572 267.803 196.21 272.533 195.441L272.591 195.432C285.685 193.292 298.588 200.753 303.273 213.162C303.344 213.349 303.415 213.558 303.491 213.78C305.773 220.588 295.704 224.231 293.048 217.558C292.986 217.402 292.924 217.246 292.866 217.086C290.045 209.611 282.272 205.118 274.419 206.399L274.362 206.408C266.455 207.698 258.362 207.311 252.169 202.252L252.116 202.208C245.94 197.162 236.97 197.162 230.782 202.217L230.75 202.243C224.548 207.311 216.451 207.694 208.522 206.404C200.638 205.113 192.861 209.607 190.04 217.086C189.978 217.246 189.92 217.402 189.853 217.562C187.197 224.231 177.129 220.592 179.411 213.785L179.407 213.789Z",
    fill: "url(#paint23_linear_1978_563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1978_563",
    x1: 125.844,
    y1: 152.437,
    x2: 441.17,
    y2: 421.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E07D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69642"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1978_563",
    x1: 303.389,
    y1: 255.607,
    x2: 589.773,
    y2: 189.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52C1C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2684,
    stopColor: "#CE2C1F",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6596,
    stopColor: "#BA2B27",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A42B31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1978_563",
    x1: 277.284,
    y1: 376.231,
    x2: 277.283,
    y2: 553.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52C1C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D12C1E",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5735,
    stopColor: "#C42C23",
    stopOpacity: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8721,
    stopColor: "#AF2B2C",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A42B31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1978_563",
    x1: 175.036,
    y1: 102.672,
    x2: 165.49,
    y2: 82.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1978_563",
    x1: 300.45,
    y1: 117.949,
    x2: 318.467,
    y2: 87.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1978_563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.743 202.138) scale(39.9617 39.9617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1978_563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(349.433 210.002) scale(47.8251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1978_563",
    x1: 168.261,
    y1: 134.06,
    x2: 194.515,
    y2: 160.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1978_563",
    x1: 302.884,
    y1: 134.06,
    x2: 329.139,
    y2: 160.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1978_563",
    x1: 243.666,
    y1: 218.972,
    x2: 246.834,
    y2: 203.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FE9636",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FE9433",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE912E",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8D26",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FE871D",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE8011",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE7804",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1978_563",
    x1: 239.226,
    y1: 218.972,
    x2: 236.058,
    y2: 203.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FE9636",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FE9433",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE912E",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8D26",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FE871D",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE8011",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE7804",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1978_563",
    x1: 305.827,
    y1: 155.869,
    x2: 322.956,
    y2: 170.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91DCFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1978_563",
    x1: 311.228,
    y1: 160.652,
    x2: 316.62,
    y2: 163.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1978_563",
    x1: 327.606,
    y1: 162.725,
    x2: 332.303,
    y2: 166.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1978_563",
    x1: 321.004,
    y1: 172.149,
    x2: 325.701,
    y2: 175.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1978_563",
    x1: 314.398,
    y1: 181.572,
    x2: 319.095,
    y2: 184.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1978_563",
    x1: 307.797,
    y1: 190.99,
    x2: 312.494,
    y2: 194.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1978_563",
    x1: 301.191,
    y1: 200.414,
    x2: 305.888,
    y2: 203.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1978_563",
    x1: 312.812,
    y1: 160.789,
    x2: 327.561,
    y2: 170.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#60B7FF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#60B7FF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#60B7FF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60B7FF",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#60B7FF",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#60B7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#60B7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1978_563",
    x1: 322.121,
    y1: 169.571,
    x2: 330.157,
    y2: 176.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1978_563",
    x1: 298.424,
    y1: 185.266,
    x2: 289.228,
    y2: 202.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#60B7FF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#60B7FF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#60B7FF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60B7FF",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#60B7FF",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#60B7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#60B7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1978_563",
    x1: 241.442,
    y1: 221.093,
    x2: 241.442,
    y2: 190.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1978_563",
    x1: 235.266,
    y1: 200.179,
    x2: 229.557,
    y2: 185.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1978_563",
    x1: 247.627,
    y1: 200.179,
    x2: 253.335,
    y2: 185.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntime);
export default __webpack_public_path__ + "static/media/downtime.b8a49d1b5c9cd307608d0fe26f089d90.svg";
export { ForwardRef as ReactComponent };